import React, { useCallback }                       from "react";
import { useSelector }                              from "react-redux";
import { tripAttr }                                 from "../../../../../shared/config/constants";
import { hrPackageTimeSelector, tripTypeSelector }  from "../../../../../shared/common/redux/selector"
import Header2                                      from '../../../../core-components/Header2/Header2UI';
import * as S                                       from "./ReviewHeader.styles";

interface IReviewHeader {
  source_city       : string
  destination_city  : string
  tripType          : string
  dateString        : string
  source            : string
  destination       : string
}

const ReviewHeaderUI: React.FC<IReviewHeader> = ({
  source_city,
  destination_city,
  tripType,
  dateString,
  source = "",
  destination = ""
}) => {
  const src             = source_city ? source_city : source;
  const desc            = destination_city ? destination_city : destination;
  const tripTypeDetails = useSelector(tripTypeSelector)
  const hrPackageTime   = useSelector(hrPackageTimeSelector)

  const showSelectedPackageTime = useCallback(
    () => {
      return hrPackageTime ? hrPackageTime.toString().includes('hr') ? hrPackageTime : `${hrPackageTime} hr` : ''
    },[hrPackageTimeSelector]
  );

  return (
    <S.HeaderCont>
			<S.HeaderContInner>
				<Header2 textColor="#fff" margin="0 0 3rem 0" name={'Review your Booking'} />
        <div className="subHeading">
          <div className="subHeading__left">
            <p>
              {tripTypeDetails?.rf === 'hr' ? (
                <>
                  {src ? <span className="subText fontSemiBold">{`${src}`}</span> : null}
                  {tripAttr[tripTypeDetails?.name]?.name ? <span className="subText">{tripAttr[tripTypeDetails?.name]?.name} {showSelectedPackageTime().length ? `- ${showSelectedPackageTime()}` : ''}</span> : null}
                </>
              ) : (
                <>
                  {src ? <span className="subText fontSemiBold">{`${src} - ${desc}`}</span> : null}
                  {tripType ? <span className="subText">{tripType}</span> : null}
                </>
              )}
              {dateString ? <span className="fontSemiBold">{dateString}</span> : null}
            </p>
          </div>
          <div className="subHeading__right">
            <span className="infoText">{'Hurry! Limited cars left'}</span>
          </div>
        </div>
      </S.HeaderContInner>
    </S.HeaderCont>
  );
};

export default ReviewHeaderUI;
